module.exports = __webpack_public_path__ + "img/chain07.3b114439.png";